import React, { useEffect } from "react";

const AdUnit = ({ slot, format = "auto", responsive = true }) => {
  useEffect(() => {
    try {
      // Push the ad only if AdSense is loaded
      if (window.adsbygoogle) {
        (window.adsbygoogle = window.adsbygoogle || []).push({});
      }
    } catch (error) {
      console.error("Error loading AdSense ad:", error);
    }
  }, []);

  return (
    <ins
      className="adsbygoogle"
      style={{ display: "block", textAlign: "center" }}
      data-ad-client="ca-pub-2928037653930901" // Replace with your AdSense publisher ID
      data-ad-slot={slot}
      data-ad-format={format}
      data-full-width-responsive={responsive}
    />
  );
};

export default AdUnit;
